// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._16jlidpf{flex-grow:0}
._16jlkb7n{flex-grow:1}
._1bsb1osq{width:100%}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/primitives/dist/esm/compiled/components/stack.compiled.css"],"names":[],"mappings":"AAAA,WAAW,WAAW;AACtB,WAAW,WAAW;AACtB,WAAW,UAAU","sourcesContent":["._16jlidpf{flex-grow:0}\n._16jlkb7n{flex-grow:1}\n._1bsb1osq{width:100%}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
